import { render } from "./SpotEditorModal.vue?vue&type=template&id=64f1ce53&scoped=true"
import script from "./SpotEditorModal.vue?vue&type=script&lang=js"
export * from "./SpotEditorModal.vue?vue&type=script&lang=js"

import "./SpotEditorModal.vue?vue&type=style&index=0&id=64f1ce53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f1ce53"]])

export default __exports__